import { useEffect, useState } from 'react';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './RelatoriosMaster.module.css';
import { MdShoppingCart, MdAttachMoney, MdStore, MdTrendingUp, MdDownload, MdDateRange } from "react-icons/md";

function RelatoriosMaster() {
    const [relatorios, setRelatorios] = useState({
        totalPedidos: 0,
        pedidosPendentes: 0,
        pedidosEmAndamento: 0,
        pedidosProntos: 0,
        pedidosEntregues: 0,
        faturamentoTotal: 0,
        ticketMedio: 0,
        pedidosPorLoja: [],
        pedidosPorHorario: [],
        produtosMaisVendidos: []
    });
    const [loading, setLoading] = useState(true);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');

    useEffect(() => {
        // Definir data padrão: últimos 30 dias
        const hoje = new Date();
        const trintaDiasAtras = new Date();
        trintaDiasAtras.setDate(hoje.getDate() - 30);

        setDataInicio(trintaDiasAtras.toISOString().split('T')[0]);
        setDataFim(hoje.toISOString().split('T')[0]);

        fetchRelatorios(trintaDiasAtras.toISOString().split('T')[0], hoje.toISOString().split('T')[0]);
    }, []);

    const fetchRelatorios = async (inicio, fim) => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            console.log('🔍 [RELATORIOS] API_URL:', API_URL);
            console.log('🔑 [RELATORIOS] Token:', token ? 'Existe' : 'Não encontrado');

            const url = `${API_URL}/master/relatorios?data_inicio=${inicio}&data_fim=${fim}`;
            console.log('📡 [RELATORIOS] Fazendo requisição para:', url);
            console.log('📅 [RELATORIOS] Período:', { data_inicio: inicio, data_fim: fim });

            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            console.log('📊 [RELATORIOS] Status da resposta:', response.status);

            if (!response.ok) {
                const errorData = await response.text();
                console.error('❌ [RELATORIOS] Erro na resposta:', errorData);
                throw new Error(`Erro ao buscar relatórios: ${response.status}`);
            }

            const data = await response.json();
            console.log('✅ [RELATORIOS] Dados recebidos:', data);

            setRelatorios(data);
            setLoading(false);
        } catch (error) {
            console.error("❌ [RELATORIOS] Erro ao buscar relatórios:", error);
            console.error("Detalhes:", error.message);
            setLoading(false);
        }
    };

    const handleFiltrar = () => {
        if (dataInicio && dataFim) {
            setLoading(true);
            fetchRelatorios(dataInicio, dataFim);
        }
    };

    const handleExportar = () => {
        alert('Funcionalidade de exportação será implementada em breve!');
    };

    const formatMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor || 0);
    };

    return (
        <div className={styles.secaoPrincipal}>
            <SideBarMaster />
            <div className={styles.containerDashboard}>
              <HeaderMaster />

                <div className={styles.contentDashboard}>
                    <div className={styles.tituloSecao}>
                        <div>
                            <h2>Relatórios e Análises</h2>
                        </div>
                    </div>

                    <div className={styles.filtroData}>
                        <div className={styles.filtroGroup}>
                            <MdDateRange className={styles.filtroIcon} /> 
                            <div className={styles.dateInputs}>
                                <div>
                                    <label>Data Início</label>
                                    <input
                                        type="date"
                                        value={dataInicio}
                                        onChange={(e) => setDataInicio(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label>Data Fim</label>
                                    <input
                                        type="date"
                                        value={dataFim}
                                        onChange={(e) => setDataFim(e.target.value)}
                                    />
                                </div>
                                <button className={styles.btnFiltrar} onClick={handleFiltrar}>
                                    Filtrar
                                </button>
                            </div>
                        </div>
                    </div>

                    {loading ? (
                        <p className={styles.loading}>Carregando relatórios...</p>
                    ) : (
                        <>
                            {/* Placar — mesmas 4 métricas, uma faixa só (sem ícone colorido
                                por item: aqui elas não são categorias diferentes, são só
                                números do mesmo período). */}
                            <div className={styles.metricsGrid}>
                                <div className={styles.metricCard}>
                                    <MdShoppingCart className={styles.metricIcon} />
                                    <div className={styles.metricContent}>
                                        <h3>Total de pedidos</h3>
                                        <p className={styles.metricValue}>{relatorios.totalPedidos}</p>
                                        <span className={styles.metricDetail}>no período selecionado</span>
                                    </div>
                                </div>

                                <div className={styles.metricCard}>
                                    <MdAttachMoney className={styles.metricIcon} />
                                    <div className={styles.metricContent}>
                                        <h3>Faturamento total</h3>
                                        <p className={styles.metricValue}>{formatMoeda(relatorios.faturamentoTotal)}</p>
                                        <span className={styles.metricDetail}>receita bruta</span>
                                    </div>
                                </div>

                                <div className={styles.metricCard}>
                                    <MdTrendingUp className={styles.metricIcon} />
                                    <div className={styles.metricContent}>
                                        <h3>Ticket médio</h3>
                                        <p className={styles.metricValue}>{formatMoeda(relatorios.ticketMedio)}</p>
                                        <span className={styles.metricDetail}>valor médio por pedido</span>
                                    </div>
                                </div>

                                <div className={styles.metricCard}>
                                    <MdStore className={styles.metricIcon} />
                                    <div className={styles.metricContent}>
                                        <h3>Pedidos entregues</h3>
                                        <p className={styles.metricValue}>{relatorios.pedidosEntregues}</p>
                                        <span className={styles.metricDetail}>
                                            {relatorios.totalPedidos > 0
                                                ? `${((relatorios.pedidosEntregues / relatorios.totalPedidos) * 100).toFixed(1)}% concluídos`
                                                : '0% concluídos'}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Status dos pedidos — aqui sim a cor carrega significado: mesmo
                                código verde/âmbar/azul usado na Tela da Cozinha e em Equipe. */}
                            <div className={styles.section}>
                                <h3 className={styles.sectionTitle}>Status dos pedidos</h3>
                                <div className={styles.statusGrid}>
                                    <div className={styles.statusCard}>
                                        <div className={`${styles.statusBadge} ${styles.statusPendente}`}>
                                            {relatorios.pedidosPendentes}
                                        </div>
                                        <p>Pendentes</p>
                                    </div>
                                    <div className={styles.statusCard}>
                                        <div className={`${styles.statusBadge} ${styles.statusAndamento}`}>
                                            {relatorios.pedidosEmAndamento}
                                        </div>
                                        <p>Em andamento</p>
                                    </div>
                                    <div className={styles.statusCard}>
                                        <div className={`${styles.statusBadge} ${styles.statusPronto}`}>
                                            {relatorios.pedidosProntos}
                                        </div>
                                        <p>Prontos</p>
                                    </div>
                                    <div className={styles.statusCard}>
                                        <div className={`${styles.statusBadge} ${styles.statusEntregue}`}>
                                            {relatorios.pedidosEntregues}
                                        </div>
                                        <p>Entregues</p>
                                    </div>
                                </div>
                            </div>

                            {/* Pedidos por Loja */}
                            <div className={styles.section}>
                                <h3 className={styles.sectionTitle}>Pedidos por Estabelecimento</h3>
                                <div className={styles.tableContainer}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th>Estabelecimento</th>
                                                <th>Total de Pedidos</th>
                                                <th>Faturamento</th>
                                                <th>Ticket Médio</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {relatorios.pedidosPorLoja && relatorios.pedidosPorLoja.length > 0 ? (
                                                relatorios.pedidosPorLoja.map((loja, index) => (
                                                    <tr key={index}>
                                                        <td className={styles.nomeLoja}>{loja.nome_lanchonete}</td>
                                                        <td>{loja.total_pedidos}</td>
                                                        <td className={styles.valorDestaque}>{formatMoeda(loja.faturamento_total)}</td>
                                                        <td>{formatMoeda(loja.ticket_medio)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className={styles.noData}>Nenhum dado disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Produtos Mais Vendidos */}
                            <div className={styles.section}>
                                <h3 className={styles.sectionTitle}>Produtos Mais Vendidos</h3>
                                <div className={styles.tableContainer}>
                                    <table className={styles.table}>
                                        <thead>
                                            <tr>
                                                <th>Posição</th>
                                                <th>Produto</th>
                                                <th>Quantidade Vendida</th>
                                                <th>Receita Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {relatorios.produtosMaisVendidos && relatorios.produtosMaisVendidos.length > 0 ? (
                                                relatorios.produtosMaisVendidos.map((produto, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <span className={styles.posicao}>#{index + 1}</span>
                                                        </td>
                                                        <td className={styles.nomeProduto}>{produto.nome_produto}</td>
                                                        <td>{produto.quantidade_vendida} unidades</td>
                                                        <td className={styles.valorDestaque}>{formatMoeda(produto.receita_total)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className={styles.noData}>Nenhum dado disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <FooterNavigationMaster />
        </div>
    );
}

export default RelatoriosMaster;
